import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useCurrentRouteData, useSiteData } from "../../services/app-state";

export const TitleUpdater = () => {
    const location = useLocation();
    const page = useCurrentRouteData(location.pathname);
    const [siteData] = useSiteData();

    const BASE_TITLE = `${siteData.siteName}`;

    const canonical = new URL(siteData.siteURL + location.pathname);
    canonical.hash = location.hash;
    canonical.search = location.search;

    return (
        <Helmet titleTemplate={`%s - ${BASE_TITLE}`} defaultTitle={`${BASE_TITLE}`}>
            {location.pathname != "/" && page ? <title>{page.title.rendered}</title> : null}
            <link rel="canonical" href={canonical.toString()} />
        </Helmet>
    );
};
